import React from "react";
import { CheckCircle2, AlertCircle, RefreshCw, Plus, Copy, XCircle } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";

const STATUS_STYLE = {
  new: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: Plus },
  replace: { cls: "bg-blue-50 text-blue-700 border-blue-200", Icon: RefreshCw },
  dup: { cls: "bg-zinc-100 text-zinc-600 border-zinc-200", Icon: Copy },
  error: { cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: AlertCircle },
  ok: { cls: "bg-emerald-100 text-emerald-800 border-emerald-300", Icon: CheckCircle2 },
  fail: { cls: "bg-red-50 text-red-700 border-red-200", Icon: XCircle },
};

export function FolderImportRow({ idx, row, status, locked, onChange }) {
  const { cls, Icon } = STATUS_STYLE[status.kind];
  return (
    <div className="flex items-center gap-3 px-3 py-2 border-b border-zinc-100 last:border-0" data-testid={`folder-import-row-${idx}`}>
      <Checkbox checked={row.include} disabled={locked || !!row.error} onCheckedChange={(v) => onChange({ include: !!v })} data-testid={`folder-import-include-${idx}`} />
      {row.thumbUrl
        ? <img src={row.thumbUrl} alt={row.name} className="w-16 h-10 object-cover rounded border border-zinc-200 flex-shrink-0" />
        : <div className="w-16 h-10 rounded border border-dashed border-zinc-300 flex-shrink-0" />}
      <span className="flex-1 min-w-0 truncate text-xs text-zinc-600" title={row.name}>{row.name}</span>
      <input
        value={row.code}
        onChange={(e) => onChange({ code: e.target.value.toUpperCase() })}
        disabled={locked || !!row.error}
        placeholder="Code"
        className="w-20 h-8 px-2 text-sm font-semibold tracking-wide border border-zinc-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-400 disabled:bg-zinc-50"
        data-testid={`folder-import-code-${idx}`}
      />
      <span className={`w-32 inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[11px] font-semibold truncate ${cls}`} title={status.label} data-testid={`folder-import-status-${idx}`}>
        <Icon className="w-3 h-3 flex-shrink-0" /><span className="truncate">{status.label}</span>
      </span>
    </div>
  );
}
